export default {
    toReadableString(value) {
        if(!value) {
            return '0,00';
        }
        let res = String(value).split('.');
        if(res[1]) {
            res[1] = res[1].length < 2 ? res[1] + '0' : res[1];
        } else {
            res.push('00');
        }
        return res[0] + ',' + res[1];
    }
};



// WEBPACK FOOTER //
// ./src/filters/NumberFilters.js